import { combineReducers } from 'redux'

import appState from './AppState'
import orders from './Orders'
import revenueCenters from './RevenueCenters'
import assets from './Assets'

export default combineReducers({
  appState,
  orders,
  revenueCenters,
  assets,
})
